<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="searchbox">
      <div style="margin-left: 10px">
        <el-input style="width: 160px; margin-right: 10px" placeholder="请输入名称" v-model="params.keyword"
          @keyup.enter.native="clickSearch" clearable size="small"></el-input>
        <el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
      </div>
      <div style="
          margin-left: 10px;
          flex: 1;
          text-align: right;
          margin-right: 10px;
        ">
        <el-button type="warning" @click="add_color" size="small">新增颜色</el-button>
        <!-- <el-button  type="warning" @click="dialogStar = true" size="small">星级价格统一</el-button> 郭雪峰 -->
        <el-button icon="el-icon-plus" type="warning" @click="addWashService()" size="small"
          v-if="$buttonAuthority('chanpin-livingbody-add')">新建活体</el-button>
      </div>
    </div>
    <div class="con" :style="{ height: fixedHeight - 82 + 'px' }">
      <div class="left">
        <el-button style="margin-left: 20px" size="mini" @click="addProductType('')">添加</el-button>
        <el-button size="mini" type="warning" @click="resetProductType">重置</el-button>
        <el-tree class="elTree" style="margin-top: 10px; font-size: 12px" v-if="categoryData[0]"
          :data="categoryData[0].children" :highlight-current="isHighlight" node-key="id" default-expand-all
          :expand-on-click-node="false" :render-content="renderContent" @node-click="handleNodeClick">
        </el-tree>
      </div>
      <div class="table">
        <el-table :data="petData" style="width: 100%" size="small">
          <el-table-column prop="category_info.name" label="分类" style="width: 150px">
          </el-table-column>
          <el-table-column prop="color" label="颜色" style="width: 150px">
          </el-table-column>
          <el-table-column prop="bron_date" label="销售价">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.pet_level" :key="index" style="margin: 5px">
                <span>{{ item.stars }}</span>星：
                <span>{{ item.price }}</span>
                <!-- <el-button style="margin-left: 5px;" icon="el-icon-view" type="text"></el-button> -->
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="bron_date" label="库存">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.stock" :key="index" style="margin: 5px">
                <span>{{ item.shopName }}</span>
                <span style="margin-left: 5px" v-for="(start, key) in item.levelInfos" :key="key">{{ start.levelName
                  }}:<span style="color: #ff0000">{{
    start.count
  }}</span></span>
                <!-- <el-button style="margin-left: 5px;" icon="el-icon-view" type="text"></el-button> -->
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="suggest_stock" label="建议库存" style="width: 150px">
          </el-table-column>
          <el-table-column prop="address" label="操作" style="width: 150px">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" size="small" @click="edit(scope.row.petCategoryId)"
                v-if="$buttonAuthority('chanpin-livingbody-edit')">编辑</el-button>
              <!-- <el-button type="text" icon='el-icon-view' size="small" @click='lookdetail(scope.row._id)'>查看</el-button> -->
              <el-button type="text" icon="el-icon-delete" size="small" @click="deleted(scope.row.petCategoryId)"
                v-if="$buttonAuthority('chanpin-livingbody-del')">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <page :total="total" :page="params.pageIndex" @change="changePage" style="padding: 10px 0"></page>
      </div>
    </div>

    <el-dialog title="活体属性" :visible.sync="dialogWashService" width="50%" :close-on-click-modal="false"
      v-if="dialogWashService">
      <!-- <div>{{ categoryData[0] }}</div> -->
      <el-form :model="editParams.editParams" label-width="150px" size="small">
        <el-form-item label="宠物分类">
          <el-cascader ref="cascader" clearable v-model="productTypeIds" :options="categoryData[0].children"
            :show-all-levels="false" :props="{ label: 'label', value: 'id' }" @change="changeCategory"></el-cascader>
        </el-form-item>
        <el-form-item label="品牌">
          <el-select style="width: 150px" clearable filterable v-model="editParams.brand_name" placeholder="请选择颜色">
            <el-option v-for="item in brandList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颜色">
          <el-select style="width: 150px" clearable filterable v-model="editParams.color" placeholder="请选择颜色">
            <el-option v-for="item in colorList" :key="item.name" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宠物级别">
          <div v-for="(item, index) in editParams.pet_level" :key="index">
            <el-input size="mini" style="width: 50px" v-model="item.stars" placeholder="请输入星级"></el-input>
            星
            <el-input size="mini" @blur="blur(item.price,item)" style="width: 120px" v-model="item.price" placeholder="请输入销售价"
              ></el-input>元
              <span> 一口价：{{ item.discount_price }}</span>  <span>补差价：{{ item.differ_price }}</span>
            <el-button type="text" v-if="index == 0" style="margin-left: 5px" @click="addStart(index)">添加</el-button>
            <el-button type="text" v-if="editParams.pet_level.length > 1 && index != 0"
              @click="deleteStart(index)">删除</el-button>
          </div>
        </el-form-item>
        <el-form-item label="建议库存">
          <el-input style="width: 150px" v-model="editParams.suggest_stock">
          </el-input>
        </el-form-item>
        <el-form-item label="公简介标题">
          <el-input style="width: 150px" v-model="editParams.male_desc">
          </el-input>
        </el-form-item>
        <el-form-item label="公简介">
          <el-input type="textarea" style="width: 300px" v-model="editParams.male_simple_desc">
          </el-input>
        </el-form-item>
        <el-form-item label="母简介标题">
          <el-input style="width: 150px" v-model="editParams.female_desc">
          </el-input>
        </el-form-item>
        <el-form-item label="母简介">
          <el-input type="textarea" style="width: 300px" v-model="editParams.female_simple_desc">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="warning" @click="editsubmit()">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="活体类型设置" :visible.sync="dialogProductType" width="30%" :close-on-click-modal="false">
      <el-form ref="editProductParams" label-width="80px">
        <el-form-item label="类型名称">
          <el-input v-model="editProductParams.typeName" size="mini" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="warning" @click="onSubmitProductType">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="星级设置" :visible.sync="dialogStar" width="30%" :close-on-click-modal="false">
      <el-form ref="editProductParams" label-width="80px">
        <el-form-item>
          <div v-for="(item, index) in starList" :key="index">
            <el-input size="mini" style="width: 50px" v-model="item.stars" placeholder="请输入星级"></el-input>
            星
            <el-input size="mini" style="width: 120px" v-model="item.price" placeholder="请输入销售价"></el-input>
            元
            <!-- <el-button type="text" v-if="index==0" style="margin-left: 5px;" @click='addStart(index)'>添加</el-button>
            <el-button type="text" v-if="editParams.pet_level.length>1&&index!=0" @click='deleteStart(index)'>删除</el-button> -->
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="editsubmitStar()">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import page from "../../../components/page.vue";
import {
  getProductPetTypeList,
  setProductPetType,
  getProductPetTypeDl,
  deleteProductPetType,
  getProductTypeList,
  setProductType,
  deleteProductType,
  getProductTypeDl,
  getColorList,
  getStartList,
  setStartPrice,
} from "../../../api/productApi.js";
export default {
  components: {
    page,
  },
  data() {
    return {
      fixedHeight: "",
      dialogWashService: false,
      petData: [],
      isHighlight: true,
      params: {
        keyword: "",
        applytype: "",
        categoryId: "",
        // shopId: this.$store.getters.curShopInfo.shop_id,
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      productTypeIds: [],
      categoryData: [],
      dialogProductType: false,
      editProductParams: {
        status: 1,
        category: "活体",
        typeName: "",
        parentId: "",
      },

      editParams: {
        petsCategoryId: "",
        brand_name: "花生",
        color: "",
        category_info: {
          name: "",
          _id: "",
        },
        category_list: [],
        pet_level: [
          {
            _id: "",
            stars: 1,
            price: 0,
            discount_price: 0,
            differ_price: 0,
          },
        ],
      },
      colorList: [],
      brandList: ["花生"],
      starData: [],
      dialogStar: false,
      starList: [],
      male_desc: '',//公简介标题
      male_simple_desc: '',//公简介
      female_desc: '',//母简介标题
      female_simple_desc: '',//母简介
    };
  },

  methods: {
    add_color() {
      this.$prompt("请输入颜色", "新增颜色", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: "",
        inputErrorMessage: "输入有误",
      }).then(({ value }) => {
        let params = {
          typeId: "",
          typeName: value, // 颜色
          customCode: "",
          parentId: "",
          lock_status: 0,
          status: 0,
          category: "",
        };
        let loading = this.$loading();
        this.$http
          .post(process.env.VUE_APP_Url_8000 + "/api/dict/Color/update", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          });
      });
    },
    getinOrderFileList() { },
    getProductPetTypeList() {
      getProductPetTypeList(this.params).then((res) => {
        if (res.code == 0) {
          this.petData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    clickSearch() {
      this.params.pageIndex = 1;
      this.getProductPetTypeList();
    },
    blur(price,item) {
      console.log(price,item, '新添加的价格');
      if (price) {
        item.discount_price=this.$public.getMatchingItem(this.starData,"custom_code",price).code1||price
        item.differ_price=this.$public.getMatchingItem(this.starData,"custom_code",price).code2||0
        console.log(this.$public.getMatchingItem(this.starData,"custom_code",price).code1||price)
      }

    },
    addStart() {
      this.editParams.pet_level.push({
        _id: "",
        stars: 1,
        price: 0,
        discount_price: 0,
        differ_price: 0,
      });
    },
    deleteStart(index) {
      this.editParams.pet_level.splice(index, 1);
    },
    changePage(val) {
      this.params.pageIndex = val;
      this.getProductPetTypeList();
    },
    addWashService() {
      this.dialogWashService = true;
      this.productTypeIds = [];
      this.editParams = {
        petsCategoryId: "",
        brand_name: "花生",
        color: "",
        category_info: {
          name: "",
          _id: "",
        },
        category_list: [],
        pet_level: [
          {
            _id: "",
            stars: 1,
            price: 0,
            discount_price: 0,
            differ_price: 0
          },
        ],
      };
      this.editParams.pet_level = this.starData.map((item) => {
        return {
          _id: item._id,
          stars: Number(item.name),
          price: Number(item.custom_code),
          discount_price: Number(item.code1),
          differ_price: Number(item.code2)
        };
      });
    },
    changeCategory(val) {
      console.log(val, "val");
      if (val.length > 0) {
        getProductTypeDl({ id: val[val.length - 1] }).then((res) => {
          if (res.code == 0) {
            this.editParams.category_info._id = res.data._id;
            this.editParams.category_info.name = res.data.name;
            this.editParams.category_info.code = res.data.code;
            this.editParams.category_list = res.data.parent_all;
          }
        });
      }
    },
    getStoreInfo(shopinfo) {
      this.editParams.shop_info = shopinfo;
    },
    editsubmit() {
      // 提交之前将重复星级去重
      const starList = this.editParams.pet_level.map((item) => item.stars);
      const starListSet = new Set(starList);

      console.log(starList, starListSet);
      if (!this.editParams.category_info._id || !this.editParams.color) {
        this.$message({
          type: "info",
          message: "请确保所有字段填写完成",
        });
      } else if (starList.length != starListSet.size) {
        this.$message({
          type: "info",
          message: "请确保星级不重复，以免造成重复定价或价格不一",
        });
      } else {
        setProductPetType(this.editParams).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "更新成功",
            });
            this.getProductPetTypeList();
            this.dialogWashService = false;
          }
        });
      }
    },
    edit(id) {
      getProductPetTypeDl({
        id,
      }).then((res) => {
        this.dialogWashService = true;
        this.productTypeIds = [];
        if (res.code == 0) {
          this.editParams = res.data;
          console.log(this.editParams, '编辑啊详情');
          res.data.category_list.forEach((item, index) => {
            if (index > 0) {
              this.productTypeIds.push(item._id);
            }
          });
          this.productTypeIds.push(res.data.category_info._id);
          console.log(this.productTypeIds);
        }
      });
    },
    deleted(id) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteProductPetType({
            id,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getProductPetTypeList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    lookdetail(id) {
      console.log(id);
    },
    getProductTypeList() {
      console.log("54674687687");
      getProductTypeList({ category: "活体" }).then((res) => {
        if (res.code == 0) {
          console.log(res.data, "????");
          this.categoryData = res.data;
        }
      });
    },
    editProductType(data) {
      console.log(data);
      this.dialogProductType = true;
      this.editProductParams.typeId = data.id;
      this.editProductParams.typeName = data.label;
      this.editProductParams.parentId = "";
      // this.editProductParams
    },

    remove(node, data) {
      this.$confirm(
        "请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          deleteProductType({
            id: data.id,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getProductTypeList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    renderContent(h, { node, data }) {
      return (
        <span class="custom-tree-node" v-if="$buttonAuthority('chanpin-goods-sort')">
          <span>{node.label}</span>
          <span class="custom-tree-btn">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-plus"
              on-click={() => this.addProductType(data)}
            ></el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              on-click={() => this.editProductType(data)}
            ></el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              on-click={() => this.remove(node, data)}
            ></el-button>
          </span>
        </span>
      );
    },
    addProductType(data) {
      if (data) {
        this.editProductParams.parentId = data.id;
        this.editProductParams.typeName = "";
        this.editProductParams.typeId = "";
      } else {
        this.editProductParams.parentId = this.categoryData[0].id;
        this.editProductParams.typeName = "";
      }

      this.dialogProductType = true;
    },

    onSubmitProductType() {
      setProductType(this.editProductParams).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "设置成功",
          });
          this.dialogProductType = false;
          this.getProductTypeList();
        }
      });
    },
    handleNodeClick(data) {
      this.params.categoryId = data.id;
      this.getProductPetTypeList();
    },
    getColorList() {
      getColorList({
        pageIndex: 0,
        pageSize: 0,
        keyword: "",
      }).then((res) => {
        if (res.code == 0) {
          console.log("颜色", res.data.data);
          this.colorList = res.data.data;
        }
      });
    },
    resetProductType() {
      this.isHighlight = false;
      this.params.categoryId = "";
      this.getProductPetTypeList();
    },
    getStartList() {
      getStartList({
        type: "价格",
        class: "宠物",
      }).then((res) => {
        console.log(res, '价格');
        if (res.code == 0) {
          let arr = res.data.data.sort((a, b) => {
            return Number(a.name) - Number(b.name);
          });
          this.starData = arr;
          console.log(arr, 'arr');
          this.starList = arr.map((item) => {
            return {
              _id: item._id,
              stars: Number(item.name),
              price: Number(item.custom_code),
              discount_price: Number(item.code1),
              differ_price: Number(item.code2)
            };
          });
        }
      });
    },
    editsubmitStar() {
      setStartPrice().then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "更新成功",
          });
        }
      });
    },
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 86;
    this.getProductPetTypeList();
    this.getProductTypeList();
    this.getColorList();
    this.getStartList();
  },
};
</script>

<style lang="scss" scoped>
.page {
  .searchbox {
    background-color: #fff;
    height: 72px;
    display: flex;
    align-items: center;
  }

  .con {
    display: flex;
    margin-top: 20px;

    .left {
      width: 180px;
      background-color: #fff;
      margin-right: 20px;
      padding: 10px;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 4px;
        // height: 4px;
      }

      .elTree {
        ::v-deep .custom-tree-node {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          padding-right: 8px;
        }

        ::v-deep .custom-tree-btn {
          display: none;
        }

        ::v-deep .custom-tree-node:hover .custom-tree-btn {
          display: block;
        }
      }
    }

    .table {
      flex: 1;
      background-color: #fff;
      padding: 0 20px;
      overflow-y: scroll;
    }
  }
}
</style>
